export const environment = {
    firebaseConfig: {
        apiKey: "AIzaSyCFoGU7KkjFDZqE7jpc8UjqB4ZA3ldOEyQ",
        authDomain: "dev-anystoreapp.firebaseapp.com",
        projectId: "dev-anystoreapp",
        storageBucket: "dev-anystoreapp.firebasestorage.app",
        messagingSenderId: "36679115155",
        appId: "1:36679115155:web:a568dfded2edc6bb400866",
        measurementId: "G-WPKJGLVE1S"
    },
    cloudFunctionProjectId: "xqa4mwr7da-uc",
    stripe_publishable_key: "pk_test_51La3NDEnL9lllxvlg3oZnNl39Y9l2G60aaaSSvPzsIt8CQ9vUaNYahE1JsWunMR18al5isY9pPT4tiDNCteVuBdH001ol0w6GZ"
};